import { render, staticRenderFns } from "./ChbPortChargesFormTableItem.vue?vue&type=template&id=2de53e8a&scoped=true"
import script from "./ChbPortChargesFormTableItem.vue?vue&type=script&lang=js"
export * from "./ChbPortChargesFormTableItem.vue?vue&type=script&lang=js"
import style0 from "./ChbPortChargesFormTableItem.vue?vue&type=style&index=0&id=2de53e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de53e8a",
  null
  
)

export default component.exports